import React, { useEffect } from "react";
import { Table } from "antd";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import organizationsStatisticsAtions from "../../../redux/organizationsStatistics/actions";
import { useProjectState } from "../../../context/stateContext";

const AdminOrganizationsStatistics = ({
  setStatisticsArray,
  statisticsTypeValue,
  statisticsArray,
}) => {
  const dispatch = useDispatch();
  const { organizationsStatistics, loading } = useSelector(
    (state) => state.organizationsStatisticsReducer
  );
  const { startDate, endDate } = useProjectState();

  const {
    getAllOrganizationsStatistics,
    getAllOrganizationsByDatesStatistics,
  } = organizationsStatisticsAtions;

  useEffect(() => {
    setStatisticsArray(organizationsStatistics);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organizationsStatistics]);

  useEffect(() => {
    dispatch(getAllOrganizationsStatistics());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      const formattedStartDate = startDate.replace(/\//g, "-");
      const formattedEndDate = endDate.replace(/\//g, "-");
      dispatch(
        getAllOrganizationsByDatesStatistics(
          formattedStartDate,
          formattedEndDate
        )
      );
    }, 1000);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate]);

  const getTotalValueFromColums = (day, byDates) => {
    const normalizeValue = (value) => (Number.isFinite(value) ? value : 0);
    if (byDates) {
      return statisticsArray
        ?.map((item) => {
          if (statisticsTypeValue === "visits") {
            return normalizeValue(item.visitsByDates);
          } else if (statisticsTypeValue === "orders") {
            return normalizeValue(item.ordersByDates);
          } else if (statisticsTypeValue === "appendOrders") {
            return normalizeValue(item.appendOrdersByDates);
          } else {
            return normalizeValue(item.myPosPaymentsByDates);
          }
        })
        ?.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    } else {
      return statisticsArray
        ?.map((item) => normalizeValue(item[statisticsTypeValue]?.[day]))
        ?.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
    }
  };

  const getByDatesValue = (record) => {
    if (statisticsTypeValue === "visits") {
      return record.visitsByDates;
    }
    if (statisticsTypeValue === "orders") {
      return record.ordersByDates;
    }
    if (statisticsTypeValue === "appendOrders") {
      return record.appendOrdersByDates;
    }
    return record.myPosPaymentsByDates;
  };

  const currentDate = dayjs();

  const formattedDate = currentDate.format("YYYY-MM-DD");

  const adminOrganizationsStatisticsTableColumn = [
    {
      title: "Заведение",
      dataIndex: "organizationName",
      align: "left",
    },
    {
      title: `${
        startDate === formattedDate && endDate === formattedDate
          ? "Днес"
          : `${dayjs(startDate).format("DD")}.${dayjs(startDate).format(
              "MM"
            )}.${dayjs(startDate).format("YY")} - ${dayjs(endDate).format(
              "DD"
            )}.${dayjs(endDate).format("MM")}.${dayjs(endDate).format("YY")}`
      } (${getTotalValueFromColums("today", true)})`,
      dataIndex: "today",
      render: (text, record) => (
        <p className="admin-organizations-statistics-column-heading">
          {statisticsTypeValue === "visits"
            ? record.visitsByDates
            : statisticsTypeValue === "orders"
            ? record.ordersByDates
            : statisticsTypeValue === "appendOrders"
            ? record.appendOrdersByDates
            : record.myPosPaymentsByDates}
        </p>
      ),
      align: "center",
      sorter: (a, b) =>
        statisticsTypeValue === "visits"
          ? a.visitsByDates - b.visitsByDates
          : statisticsTypeValue === "orders"
          ? a.ordersByDates - b.ordersByDates
          : statisticsTypeValue === "appendOrders"
          ? a.appendOrdersByDates - b.appendOrdersByDates
          : a.myPosPaymentsByDates - b.myPosPaymentsByDates,
    },
    {
      title: `Вчера (${getTotalValueFromColums("yesterday", false)})`,
      dataIndex: "yestarday",
      render: (text, record) => (
        <p className="admin-organizations-statistics-column-heading">
          {record[statisticsTypeValue]?.yesterday}
        </p>
      ),
      align: "center",
      sorter: (a, b) =>
        (a[statisticsTypeValue]?.yesterday || 0) - (b[statisticsTypeValue]?.yesterday || 0),
    },
    {
      title: `Последните 7 дни (${getTotalValueFromColums("lastWeek", false)})`,
      dataIndex: "lastweek",
      render: (text, record) => (
        <p className="admin-organizations-statistics-column-heading">
          {record[statisticsTypeValue]?.lastWeek}
        </p>
      ),
      align: "center",
      sorter: (a, b) =>
        (a[statisticsTypeValue]?.lastWeek || 0) - (b[statisticsTypeValue]?.lastWeek || 0),
    },
    {
      title: `Последните 30 дни (${getTotalValueFromColums(
        "lastMonth",
        false
      )})`,
      dataIndex: "lastMonth",
      render: (text, record) => (
        <p className="admin-organizations-statistics-column-heading">
          {record[statisticsTypeValue]?.lastMonth}
        </p>
      ),
      align: "right",
      sorter: (a, b) =>
        (a[statisticsTypeValue]?.lastMonth || 0) - (b[statisticsTypeValue]?.lastMonth || 0),
    },
  ];

  return (
    <>
      <Table
        className="admin-organizations-statistics-table"
        size="small"
        loading={organizationsStatistics?.length === 0 && loading}
        columns={adminOrganizationsStatisticsTableColumn}
        dataSource={statisticsArray?.filter(
          (org) => {
            const byDatesValue = getByDatesValue(org);
            const fallbackValue = org[statisticsTypeValue]?.allTime || 0;
            const selectedValue =
              byDatesValue !== null && byDatesValue !== undefined
                ? byDatesValue
                : fallbackValue;
            return selectedValue > 0;
          }
        )}
        rowKey="organizationId"
        pagination={{
          defaultPageSize: 50,
          showSizeChanger: true,
          pageSizeOptions: ["10", "25", "50", "100"],
        }}
      />
    </>
  );
};
export default AdminOrganizationsStatistics;
